// extracted by mini-css-extract-plugin
module.exports = {"tile":"aby_i2","tileImage":"aby_abz aby_i2","tileImageText":"aby_ab0","tileText":"aby_ab1 aby_i2","primaryText":"aby_ab2 aby_ab1 aby_i2","secondaryText":"aby_bo aby_ab1 aby_i2"};